export const companyInfo = {
  name: "Blue Lantern Outfitters LLC",
  displayName: "BlueLanternOutFitters",
  domain: "Bluelanternoutfitters.com",
  email: "support@Bluelanternoutfitters.com",
  phone: "+1 707 755 6377",
  address: "1527W Harriet Ln, Anaheim, CA 92802",
  mailingAddress: "1527W Harriet Ln, Anaheim, CA 92802"
};

export const stats = [
  { value: "50M+", label: "Orders Fulfilled" },
  { value: "15K+", label: "Active Sellers" },
  { value: "200+", label: "Countries Served" },
  { value: "99.2%", label: "On-time Delivery" }
];

export const services = [
  {
    id: 1,
    title: "Dropshipping Fulfillment",
    description: "End-to-end order processing with pick, pack, and ship services. We handle your entire supply chain so you can focus on selling.",
    icon: "Truck"
  },
  {
    id: 2,
    title: "Print on Demand",
    description: "Custom t-shirts, mugs, phone cases, posters, and more. No inventory risk — we print and ship each order as it comes in.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "Product Sourcing",
    description: "Direct factory connections across China, including 1688 and Alibaba. We negotiate prices, verify quality, and manage suppliers.",
    icon: "Search"
  },
  {
    id: 4,
    title: "Global Warehousing",
    description: "Strategic warehouse locations in China, USA, Europe, and Australia. Store inventory closer to your customers for faster delivery.",
    icon: "Warehouse"
  },
  {
    id: 5,
    title: "Custom Branding",
    description: "Make every package feel premium with custom logos, branded packaging, thank-you cards, and promotional inserts.",
    icon: "Star"
  },
  {
    id: 6,
    title: "TikTok Shop Solutions",
    description: "Full TikTok Shop fulfillment with SCAN label support, rapid processing for viral products, and seamless platform integration.",
    icon: "Video"
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Connect Your Store",
    description: "Integrate your Shopify, WooCommerce, Etsy, TikTok Shop, or any other platform in just a few clicks."
  },
  {
    step: 2,
    title: "We Source & Stock",
    description: "Our team sources high-quality products and stocks them in our global warehouses, ready for fulfillment."
  },
  {
    step: 3,
    title: "Orders Auto-Sync",
    description: "When customers place orders, they're automatically synced to our system — no manual input required."
  },
  {
    step: 4,
    title: "We Ship to Customers",
    description: "We pick, pack, and ship directly to your customers worldwide with tracking and branded packaging."
  }
];

export const advantages = [
  {
    title: "Lightning-Fast Processing",
    description: "Most orders processed within 24-48 hours. Express options available for time-sensitive products.",
    icon: "Zap"
  },
  {
    title: "Quality Guaranteed",
    description: "Every item goes through a rigorous 3-step quality check before shipping. We stand behind every package.",
    icon: "Shield"
  },
  {
    title: "Dedicated Support",
    description: "Your personal account manager is available 7 days a week via live chat, email, or WhatsApp.",
    icon: "Headphones"
  },
  {
    title: "Competitive Pricing",
    description: "No hidden fees. Transparent pricing with volume discounts. Pay only for what you use.",
    icon: "DollarSign"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "BlueLanternOutFitters transformed our fulfillment process. We went from handling 50 orders a day to 500 without hiring a single new employee. Their team is responsive, reliable, and truly understands ecommerce.",
    author: "Sarah Reynolds",
    position: "CEO, TrendVault Co.",
    initials: "SR"
  },
  {
    id: 2,
    quote: "We've been using their POD service. The print quality is consistently excellent, shipping times have improved dramatically, and our customers love the branded packaging.",
    author: "Marcus Kim",
    position: "Founder, DesignHype Studio",
    initials: "MK"
  },
  {
    id: 3,
    quote: "Their TikTok Shop integration is a game-changer. When our products go viral, BlueLanternOutFitters scales up instantly. They handled a 10x spike in orders without missing a beat.",
    author: "Jessica Liu",
    position: "Director, SocialPeak Brands",
    initials: "JL"
  }
];

export const integrations = [
  { name: "Shopify", logo: "shopify" },
  { name: "WooCommerce", logo: "woocommerce" },
  { name: "Etsy", logo: "etsy" },
  { name: "TikTok Shop", logo: "tiktok" },
  { name: "Amazon", logo: "amazon" },
  { name: "eBay", logo: "ebay" }
];

export const faqData = [
  {
    id: 1,
    question: "What is Print on Demand?",
    answer: "Print on Demand (POD) is a fulfillment method where products are only created after a customer places an order. This eliminates the need for inventory and reduces upfront costs. We print and ship products like t-shirts, mugs, phone cases, and posters on-demand."
  },
  {
    id: 2,
    question: "How long does shipping take?",
    answer: "Domestic orders typically take 3-7 business days, while international orders take 7-14 business days. We also offer express shipping options for faster delivery. Processing time is usually 24-48 hours before shipment."
  },
  {
    id: 3,
    question: "What platforms do you integrate with?",
    answer: "We integrate with all major ecommerce platforms including Shopify, WooCommerce, Etsy, TikTok Shop, Amazon, and eBay. Integration typically takes just a few clicks and can be set up in minutes."
  },
  {
    id: 4,
    question: "What are your pricing fees?",
    answer: "Our pricing is transparent with no hidden fees. You pay only for the products you order and shipping costs. We offer volume discounts for larger orders. Contact us for a detailed pricing quote tailored to your needs."
  },
  {
    id: 5,
    question: "Do you offer custom branding?",
    answer: "Yes! We offer comprehensive custom branding including custom logos on products, branded packaging, thank-you cards, and promotional inserts. Make every package feel premium and build your brand identity."
  },
  {
    id: 6,
    question: "What quality control measures do you have?",
    answer: "Every product goes through a rigorous 3-step quality check before shipping. We inspect for print quality, product defects, and packaging integrity. We stand behind every package and offer replacements for any quality issues."
  },
  {
    id: 7,
    question: "How do I get started?",
    answer: "Getting started is easy! Simply contact us for a free consultation, connect your store to our platform, and start syncing orders. Our team will guide you through the entire onboarding process."
  },
  {
    id: 8,
    question: "Do you handle returns and customer support?",
    answer: "Yes, we can handle returns processing and provide customer support on your behalf. We also offer dedicated account managers who are available 7 days a week via live chat, email, or WhatsApp."
  }
];
